import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { useSlideDock } from '../hooks/useSlideDock'
import NodeDrawer from '../NodeDrawer'

// The node drawer, sliding in and out the way the web call dock does.
//
// It used to appear and vanish on `selectedNodeId`, which snapped 480px off the
// canvas in one frame — the graph you were reading jumped sideways and you had
// to find your place again. Same treatment as the call dock now: the column
// widens while the panel slides in from the right, and reverses on close, so
// the canvas has a movement to follow rather than a jump-cut.
//
// Selecting a *different* node while the drawer is open doesn't animate. The
// panel is already there and only its contents change — re-running the slide
// would make every node click feel like opening the drawer from scratch.
const NodeDrawerDock = () => {
  const selectedNodeId = useSelector((state) => state.voiceAgents.selectedNodeId)
  const { mounted, entered, ref } = useSlideDock(Boolean(selectedNodeId))

  // The node the drawer is showing. Held past deselection so the exit animation
  // has content to carry out; NodeDrawer renders nothing without a node, and an
  // empty 480px box collapsing is worse than no animation at all.
  const shownNodeId = useRef(selectedNodeId)
  useEffect(() => {
    if (selectedNodeId) {
      shownNodeId.current = selectedNodeId
    }
  }, [selectedNodeId])

  if (!mounted) {
    return null
  }

  return (
    <div
      ref={ref}
      className={classNames('voice-agents__drawer-dock', {
        'voice-agents__drawer-dock--open': entered,
      })}
      data-testid="node-drawer-dock"
    >
      <NodeDrawer nodeId={selectedNodeId || shownNodeId.current} />
    </div>
  )
}

export default NodeDrawerDock
